import React, { useEffect, useState, lazy, Suspense } from 'react';
import useApi, { GET_AVAILABLE_HOLDINGS } from 'hooks/useApi';
import Container from 'components/Container';
import Page from 'layout/Page';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

import LoadingSpinner from 'components/LoadingSpinner';

const DashboardsList = lazy(() => import('../DashboardsList/DashboardsList'));

const ITEM_INTERVAL = 20;

const Holdings = () => {
  const [state, makeRequest] = useApi();
  const [items, setItems] = useState();
  const [itemsToDisplay, setItemsToDisplay] = useState(ITEM_INTERVAL);
  const { data } = state;

  useEffect(() => {
    makeRequest(GET_AVAILABLE_HOLDINGS());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (data) {
      setItems([...data.slice(0, itemsToDisplay)]);
    }
  }, [data, itemsToDisplay]);

  const handleDisplayMoreHoldings = () => {
    if (data && data.length && itemsToDisplay < data.length) {
      const remainingItemsInterval =
        data.length - itemsToDisplay >= ITEM_INTERVAL
          ? ITEM_INTERVAL
          : data.length - itemsToDisplay;

      setItemsToDisplay(prevState => prevState + remainingItemsInterval);
    }
  };

  const scrollRef = useBottomScrollListener(handleDisplayMoreHoldings, 20, 0);

  return (
    <Page title="Holdings">
      <Container ref={scrollRef} size={100} center maxWidth="xl">
        <Suspense fallback={<LoadingSpinner />}>
          <DashboardsList linkUrlPrefix="canned" items={data && data.length && items} />
        </Suspense>
      </Container>
    </Page>
  );
};

export default Holdings;
